package com.essntl.features.client.ui

import androidx.compose.foundation.layout.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.essntl.core.utils.viewmodel.PaginationState
import com.essntl.features.client.domain.model.ClientModel
import com.essntl.uikit.components.button.outline.EsMediumOutlineButton
import com.essntl.uikit.components.button.primary.EsLargePrimaryButton
import com.essntl.uikit.components.dialog.EsDialog
import com.essntl.uikit.components.dropdown.EsInputDropdownMenu
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.icons.EsMediumIcon
import com.essntl.uikit.components.input.EsInput
import com.essntl.uikit.components.utils.spacing
import kotlinx.coroutines.Job
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch

@Composable
fun SelectClientDialog(
    isOpen: Boolean,
    onDismissRequest: () -> Unit,
    getAllClients: PaginationState<ClientModel>,
    onSearchTextChange: (String) -> Unit,
    onSelectClient: (ClientModel) -> Unit,
    onLoadMoreClient: () -> Unit,
) {
    var client by remember { mutableStateOf(ClientModel.empty) }
    val scope = rememberCoroutineScope()
    var searchText by remember { mutableStateOf("") }
    var searchJob: Job? by remember { mutableStateOf(null) }

    LaunchedEffect(isOpen) {
        if (isOpen) {
            client = ClientModel.empty
            searchText = ""
            searchJob = null
            onLoadMoreClient()
        }
    }

    if (isOpen) {
        EsDialog(
            title = "Add existing traveller",
            onDismissRequest = onDismissRequest,
        ) {
            Column(
                verticalArrangement = Arrangement.Center,
                horizontalAlignment = Alignment.CenterHorizontally,
                modifier = Modifier
                    .padding(2.5.spacing),
            ) {
                Spacer(modifier = Modifier.height(3.spacing))
                EsInputDropdownMenu(
                    items = getAllClients.data,
                    selectedItem = client,
                    text = { it.prettyName },
                    onItemSelected = { client = it },
                    label = "Traveller",
                    placeholder = "Select",
                    loading = getAllClients.isLoading,
                    topContent = {
                        Spacer(Modifier.height(0.5.spacing))
                        EsInput(
                            value = searchText,
                            onValueChange = {
                                searchJob?.cancel()
                                searchJob = scope.launch {
                                    searchText = it
                                    delay(500)
                                    onSearchTextChange(it)
                                }
                            },
                            placeholder = "Search",
                            prefix = {
                                EsMediumIcon(res = EsIcons.Search)
                            },
                            modifier = Modifier
                                .fillMaxWidth(),
                        )
                    },
                ) {
                    if (!getAllClients.isLastPage) {
                        Spacer(modifier = Modifier.height(2.spacing))

                        EsMediumOutlineButton(
                            onClick = {
                                onLoadMoreClient()
                            },
                            text = "Load more",
                            loading = getAllClients.isLoading,
                            modifier = Modifier
                                .align(Alignment.CenterHorizontally),
                        )
                    }
                }

                Spacer(modifier = Modifier.height(4.5.spacing))

                EsLargePrimaryButton(
                    text = "Confirm",
                    onClick = {
                        onSelectClient(client)
                    },
                    enabled = getAllClients.data.isNotEmpty() &&
                        !getAllClients.isLoading &&
                        !getAllClients.isFailure &&
                        client != ClientModel.empty,
                    modifier = Modifier
                        .fillMaxWidth(),
                )
            }
        }
    }
}